export default {
  image: 'A4_5_2.png',
  pdf: '220922_WA-MIWO_003_A4_5_2_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-MIWO-003',
    technicalValues: {
      soundReductionIndex: {
        output: '48,9',
        value: 48.9
      },
      heatTransferCoefficient: {
        output: '0,16',
        value: 0.16
      },
      fireBehavior: {
        output: 'nichtbrennbar (A2-s1, d0)',
        value: 'A1A2'
      },
      fireResistanceOuter: {
        output: 'F 90-B',
        value: 'F-90-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 3',
    construction: {
      composition: [
        {
          output: 'mineralischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'min-1'
        },
        {
          output: '40 mm Sto-Speedlamelle Typ ll',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'msp-40'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '60/200',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-200'
        },
        {
          output: '200 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-200'
        },
        {
          output: '12 mm OSB-Platte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ia-12'
        },
        {
          output: '12,5 mm Gipskartonplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'in-12'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '288',
        value: 288
      }
    }
  }
}
